import React from 'react';

// Import required components
import { Offer } from '../../../components';
import { offers } from '../../../constants';

// Import Swiper core and required modules
import { Autoplay } from 'swiper/modules';

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';



const Offers = () => { 

  return (
    <section className='offers'>

      <Swiper

        modules={[Autoplay]} // Enable Autoplay feature
        spaceBetween={10} // Space between slides
        loop={true} // Enables Infinite Loop
        autoplay={{ delay: 4000, disableOnInteraction: false }} // Auto-scroll every 4 seconds

        // Responsive Breakpoints for Different Screen Sizes
        breakpoints={{
          768: { slidesPerView: 1 }, // 1 slides for tablets
          991: { slidesPerView: 2 }, // 2 slides for larger screens
        }}

      >
        
        {/* Map over the offers array to render each offer */}
        {offers.map((offer) => { 
          return (
            <SwiperSlide key={offer.id}>

              {/* Render individual offer component */}
              <Offer offer={offer} />

            </SwiperSlide>
          );
        })}
      </Swiper>

    </section>
  )
}

export default Offers;